import { EChartsOption } from 'echarts';
import ReactECharts from 'echarts-for-react';
import { useTranslation } from 'react-i18next';
import { ColumnChartModel } from 'services/Main/campaign_services';

export interface ChartDataType {
  name: string;
  total?: number[];
  stack?: string;
  fontSize?: number;
}

export interface BarChartProps {
  valueName?: string[];
  color?: string[];
  className?: string;
  title?: string;
  subTitle?: string;
  dataChart: ColumnChartModel[]
}

function BarChartCampaign({ ...props }: BarChartProps) {
  var option: EChartsOption;

  const screenWidth = window.screen.width;

  const arrayColor = ['#015874', '#a9df96', '#e6486d', '#f6dc7d']

  //=====================================CHUYỂN NGÔN NGỮ=====================================//
  const { t } = useTranslation();

  option = {
    title: {
      text: props.title,
      subtext: props.subTitle,
      right: 'center',
      textStyle: {
        fontFamily: 'roboto',
      },
      subtextStyle: {
        fontFamily: 'roboto',
        fontSize: '14px',
        fontWeight: 'bold',
        color: props.color ? props.color[0] : '#5AC29C',
      },
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontFamily: 'inherit',
        fontSize: 12,
      },
      borderRadius: 3,
      borderWidth: 0,
      shadowOffsetX: 0,
      shadowOffsetY: 1,
      shadowBlur: 3,
      shadowColor: 'rgba(0, 0, 0, 0.25)',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#C5DFEB',
          fontFamily: 'roboto',
          fontSize: 10,
          fontWeight: 400,
        },
      },
      className:
        '[&>div>:nth-child(1)>:nth-child(2)>div>:nth-child(1)>:nth-child(1)]:!rounded-[1px] ' +
        '[&>div>:nth-child(1)>:nth-child(2)>div>:nth-child(1)>:nth-child(1)]:!w-[19px] ' +
        '[&>div>:nth-child(1)>:nth-child(2)>div>:nth-child(1)>:nth-child(1)]:!h-[12px] ' +
        '[&>div>:nth-child(1)>:nth-child(1)]:!font-semibold ' +
        '[&>div>:nth-child(1)>:nth-child(1)]:!text-textColor',
    },
    color: props.color ? props.color : ['#5AC29C', '#5281BB'],
    legend: {
      itemGap: 5,
      textStyle: {
        fontFamily: 'roboto',
        fontSize: 10,
        color: '#77838F',
      },
    },
    toolbox: {
      show: false,
      feature: {
        dataView: { readOnly: false },
        restore: {},
        saveAsImage: {},
      },
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      data: props.dataChart?.map(item => item.name),
    },
    yAxis: {
      minInterval: 1
    },

    series: [
      {
        type: 'bar',
        data: props.dataChart?.map((item, index) => {
          return {
            value: item.value,
            groupId: item.name,
            itemStyle: {
              color: arrayColor[index]
            }
          }
        })
        // label: {
        //   show: true,
        //   position: 'right',
        //   valueAnimation: true
        // }
      }
    ]
  };

  return <ReactECharts option={option} className={props.className} />;
}

export default BarChartCampaign;
